export default "__VITE_ASSET__bbef7e4a__"